import { TransactionDirection, TransactionStatus } from '../../../enums';
import { Address } from '../../../types';
import { apiDocgenSlice } from '../../api';

const injectedRtkApi = apiDocgenSlice.injectEndpoints({
  endpoints: (build) => ({
    downloadWithdrawalOrderPdf: build.mutation<
      DownloadWithdrawalOrderResult,
      DownloadWithdrawalOrderDto
    >({
      query: (body) => ({
        url: '/v1/withdrawal-order/pdf',
        method: 'POST',
        body,
        responseHandler: async (response) => {
          if (!response.ok) {
            return;
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'withdrawal-order.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
      }),
    }),
    downloadWithdrawalOrderDocx: build.mutation<
      DownloadWithdrawalOrderResult,
      DownloadWithdrawalOrderDto
    >({
      query: (body) => ({
        url: '/v1/withdrawal-order/docx',
        method: 'POST',
        body,
        responseHandler: async (response) => {
          if (!response.ok) {
            return;
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'withdrawal-order.docx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        },
      }),
    }),
  }),
});
export { injectedRtkApi as abfpayDoxgenServiceApi };
export type DownloadWithdrawalOrderResult = unknown;

export type DownloadWithdrawalOrderDto = {
  current_date: string;
  number: string;
  client_name: string;
  client_id: string;
  client_email: string;
  client_phone: string;
  withdrawal_amount: string;
  withdrawal_date: string;
  withdrawal_reference: string;
  acc_beneficiary_name: string;
  acc_bank_name: string;
  acc_iban: string;
  acc_swift: string;
  acc_bank_address: string;
};

export const { useDownloadWithdrawalOrderPdfMutation, useDownloadWithdrawalOrderDocxMutation } =
  injectedRtkApi;
